import { createSlice } from "@reduxjs/toolkit";

// Initial state and other actions assumed to be defined already
const dndSlice = createSlice({
  name: "dnd",
  initialState: {
    items: [
      { id: "1", type: "fluxos" },
      { id: "2", type: "tarefas" },
      { id: "3", type: "colaboradores" },
    ],
  },
  reducers: {
    updateActiveReports(state, action) {
      state.items = action.payload;
    },
  },
});

export const { updateActiveReports } = dndSlice.actions;
export default dndSlice.reducer;
